import { needPersonalize } from 'feature/personalize/util'
import { useEffectOnce } from 'hook/useEffectOnce'
import { makeAutoObservable } from 'mobx'
import { useEffect } from 'react'
import { mx } from 'store/base/mx'
import { InferenceStore } from 'store/inference/InferenceStore'
import ProfileStore from 'store/profile/ProfileStore'

export class PersonalizeBannerStore {
  readonly inference: InferenceStore
  readonly profile: ProfileStore
  dont = false
  photo = false

  constructor(inference: InferenceStore, profile: ProfileStore) {
    this.inference = inference
    this.profile = profile
    makeAutoObservable(this)
  }
}

export const personalize_banner = mx.ref<PersonalizeBannerStore>()

export function usePersonalizeBanner(inference: InferenceStore | undefined) {
  const banner = personalize_banner.optional
  const profile = banner?.profile ?? needPersonalize(inference)

  useEffect(() => {
    if (inference && profile) {
      personalize_banner.open(new PersonalizeBannerStore(inference, profile))
    } else {
      personalize_banner.close()
    }
  }, [inference, profile])

  useEffectOnce(() => {
    return () => personalize_banner.close()
  })
}
